import script from "./Card.vue?vue&type=script&lang=ts&setup=true"
export * from "./Card.vue?vue&type=script&lang=ts&setup=true"

import "./Card.vue?vue&type=style&index=0&id=7083b8e6&lang=scss"

const __exports__ = script;

export default __exports__